module.exports = __webpack_public_path__ + "static/media/silhouette.cdfd8cd8.svg";